import Settings from "../components/settings/Settings";

export default function SettingsPage() {
  return <Settings />;
}